import { FC } from "react";
import AnchorDataOverviewList from "@/components/anchorDataOverview/anchorDataOverviewList";

const AnchorDataOverview: FC = () => {
  return <AnchorDataOverviewList />;
};

export default AnchorDataOverview;
